import { makeAutoObservable } from "mobx";
import { SystemInfoEntity } from "../entity/system-info-entity";

export class SystemStore {
    constructor() {
        makeAutoObservable(this);
    }

    public systemInfo:SystemInfoEntity|undefined;
    public copyright:string = '';
    public addr:string = '';
    public link:string = '';
    public linktel:string = '';
    public email:string = '';
    public id:string = '';

    public setSystemInfo(systemInfo: SystemInfoEntity) {
        this.systemInfo = systemInfo;
    }

    public setCopyright(copyright: string) {
        this.copyright = copyright;
    }

    public setAddr(addr: string) {
        this.addr = addr;
    }

    public setLink(link: string) {
        this.link = link;
    }

    public setLinktel(linktel: string) {
        this.linktel = linktel;
    }

    public setEmail(email: string) {
        this.email = email;
    }

    public setId(id: string) {
        this.id = id;
    }
}